export default __webpack_public_path__ + "static/media/hr-payroll-management.ceaab7f1.svg";